import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { TagService } from '@shared/services/tag.service';
import { TagModel } from '@shared/models/tag.model';
import { SubCategory } from '@shared/models/sub-category';
import { Config } from '@core/config';
import { SubCategoriesService } from '@shared/services/sub-categories.service';
import {
  CardList,
  CircuitDifficulty,
  DIFFICULTY_MAPPING,
  mappingProducteur,
} from '@shared/models/card-list';
import { CardsService } from '@shared/services/cards.service';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { FilterFieldService } from '@shared/services/filter_field.service';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FilterCountService } from '@shared/services/filter_count.service';
import { MatSelectionList } from '@angular/material/list/selection-list';
import { Options } from '@angular-slider/ngx-slider';
import { GAService } from '@app/@shared/services/google-analytics.service';
import { FilterCacheService } from './filter_cache.service';
import { FormsService } from '@shared/services/forms.service';
import { TriggerMapZoomService } from '@app/trigger-map-zoom.service';
import { ResponseData } from '@app/@shared/models/temp-form';

interface TagNested {
  cat: {
    name: string;
    catId: string;
    subCatId: string | null;
    isTag: boolean;
    isEnable?: boolean;
  };
  children: TagNested[];
}

@Component({
  selector: 'card-list-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FiltersComponent implements OnInit, OnDestroy {
  @Output() filteredCards = new EventEmitter<CardList[]>();
  @Input() filterPanel: BehaviorSubject<boolean>;
  @ViewChild('chipList') chipList: MatChipList;
  @ViewChild('tag_list') tag_list: MatSelectionList;
  public catId: string | null;
  public subCatId: string | null;
  public tags: TagModel[];
  public subCat: SubCategory[];
  public tagsByCat: Record<string, TagModel[]> = {};
  public titleByCat: Record<string, string> = {};
  public cardFilters: TagNested[] = [];
  public checkedList: {
    name: string;
    catId: string;
    subCatId: string | null;
    isTag: boolean;
  }[] = [];
  public manualCheckedList: {
    name: string;
    catId: string;
    subCatId: string | null;
    isTag: boolean;
  }[] = [];
  public circuitType: any[];
  public panelDisable: boolean;
  public catName: string;
  public cards: CardList[];

  public filtersInput: string[] = [];
  public mainChipInputList: string[] = [];
  public secondChipInputList: string[] = [];
  public tagsSelected: string[] = [];

  public isSp: boolean;
  public seeExpand: boolean;
  public removeMinHeight: boolean;
  public tagFiltered: CardList[];
  public maxDist = 0;
  public maxDur = 0.0;
  public difficultyValue: CircuitDifficulty[] = [];
  public isLoop = false;
  public isLinear = false;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public isMobile: boolean;
  public catList = ['Heritages', 'Circuits', 'Services', 'Events', 'Games'];
  public isCdesi = false;
  public sortieNature = false;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public catFilter: string;

  public startDate: FormControl;
  public endDate: FormControl;

  public tagNested: TagNested[] = [];
  private filterFieldInput: string;
  private allCards: CardList[];
  private resizeEvent: ResizeObserver;
  private webWorker: Worker;
  private subscriptions: Subscription[];

  public isDist: boolean;
  public disabledAccess: boolean;
  public minDistValue: number = 0;
  public maxDistValue: number = 60;
  public minTimeValue: number = 0;
  public maxTimeValue: number = 7;
  public minValue: number;
  public maxValue: number;
  public minValueElevation: number;
  public maxValueElevation: number;
  public options: Options;
  public optionsElevation: Options;

  public static _translateCircuitType(
    circuitType: number,
    mainType: number
  ): boolean {
    // tslint:disable-next-line:no-bitwise
    return (circuitType & mainType) > 0;
  }

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private tagService: TagService,
    private subCatService: SubCategoriesService,
    private triggerMapZoom: TriggerMapZoomService,
    private cardsService: CardsService,
    private filterField: FilterFieldService,
    private filtersCount: FilterCountService,
    public gaService: GAService,
    private filterCacheService: FilterCacheService,
    public formService: FormsService
  ) {
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    this.maxDist = Config.maxDist;
    this.maxDur = Config.maxDur;
    this.removeMinHeight = false;
    this.circuitType = Config.circuit;
    this.panelDisable = false;
    this.isSp = window.outerWidth < 600;
    this.subscriptions = [];
    Object.values(Config.categories).forEach((cat) => {
      this.tagNested.push({
        cat: {
          catId: cat.id.toString(),
          name: cat.name,
          subCatId: null,
          isTag: false,
        },
        children: [],
      });
    });
    this.tagNested.forEach((tn) => {
      if (tn.cat.catId === '1') {
        tn.children = Config.circuit.map((c) => ({
          cat: {
            catId: '1',
            name: c.name,
            subCatId: c.id.toString(),
            isTag: false,
          },
          children: [],
        }));
      }
      if (tn.cat.catId === '3') {
        tn.children = [
          {
            cat: {
              catId: '3',
              name: 'Actuellement',
              subCatId: '0',
              isTag: false,
              isEnable: false,
            },
            children: [],
          },
          {
            cat: { catId: '3', name: 'À venir', subCatId: '1', isTag: false },
            children: [],
          },
        ];
      }
    });
  }

  ngOnInit(): void {
    const state = this.filterCacheService.getState();

    // PMR
    this.disabledAccess = state.isPMR;
    this.setPMRValue(false);
    this.disabledAccess = false;

    this.filtersInput = state.filtersInput;
    this.mainChipInputList = state.mainChipInputList;
    this.secondChipInputList = state.secondChipInputList;
    this.tagsSelected = state.tagsSelected;

    // Circuit distance or duration
    this.isDist = state.isDist;
    this.minValue = Number(state.minValue);
    this.maxValue = Number(state.maxValue);
    this.handleCircuitDistDurationFilter(false);

    // Circuit denivele
    this.minValueElevation = Number(state.minValueElevation);
    this.maxValueElevation = Number(state.maxValueElevation);
    this.handleElevationFilter(false);

    // // Circuit difficulty
    this.difficultyValue = [];
    for (const diff of state.difficulty) {
      this.setDifficultyValue(diff.id, diff.name, false);
    }

    // Circuit loop/linear
    this.isLoop = state.isLoop;
    this.setLoopValue(false);
    this.isLinear = state.isLinear;
    this.setLinearValue(false);

    // // Circuit Cdesi
    this.isCdesi = state.isCdesi;
    this.handleCdesiValue(false);

    // // Agenda Sorties Nature
    this.sortieNature = state.sortieNature;
    this.handleSortieNatureValue(false);

    this.optionsElevation = {
      floor: 0,
      ceil: 1000,
      step: 10,
      hidePointerLabels: true,
      hideLimitLabels: true,
    };

    this.setCircuiCursorOptions();

    const a = new Date(state.startDate);
    const b = new Date(state.endDate);

    this.startDate =
      state.startDate == null ? new FormControl() : new FormControl(a);
    this.endDate =
      state.endDate == null ? new FormControl() : new FormControl(b);

    this.router.onSameUrlNavigation = 'reload';
    if (typeof Worker !== 'undefined') {
      this.webWorker = new Worker(
        new URL('filter-web-worker.worker', import.meta.url)
      );
      this.webWorker.onmessage = (data) => {
        this.cards = data.data;
        this.filteredCards.emit(this.cards);
        this.triggerMapZoom.triggerZoom(this.cards);
      };
    }
    this._fetchData();

    // link with search-field
    if (this.catId === undefined || this.isMobile) {
      this.subscriptions.push(
        this.filterField.sharedValue$.subscribe((data) => {
          if (data.filter == null) return;

          if (
            data.filter.length > 0 &&
            !this.filtersInput.includes(data.filter)
          ) {
            this.filterFieldInput = data.filter;
            // ? SET FILTERS INPUT. ?
            this.filtersInput.push(this.filterFieldInput);
            this.mainChipInputList.push(this.filterFieldInput);
            // ? SET FILTERS INPUT. ?
          } else if (this.filterFieldInput?.length > 0 && !this.isMobile) {
            this.removeMainFilterChip(this.filterFieldInput);
            this.removeSecondaryFilterChip(this.filterFieldInput);
            this.filterFieldInput = '';
          }
          this.filtersCount.sharedValue$.next(
            this.filtersInput.length +
              this.checkedList.length +
              this.manualCheckedList.length
          );
          this.filterByTag();
        })
      );
    } else {
      this.filterField.sharedValue$.next({ filter: '' });
      this.filtersCount.sharedValue$.next(0);
    }

    this.resizeEvent = new ResizeObserver((s) => {
      this.seeExpand = s[0].contentRect.height >= 136;
    });

    this._getCards();
    this.updateFilter();
    this._groupTagsByCategory();

    if (document.querySelector('#divChip') !== null) {
      this.resizeEvent.observe(document.querySelector('#divChip'));
    }

    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        const navStart = event as NavigationStart;
        const urlString = navStart?.url?.substring(0, 6) ?? '';

        if (event instanceof NavigationEnd) {
          if (urlString != '/fiche') {
            this.removeAllFilters();
            this.filterCacheService.resetStoredValues();
          }
          this.ngOnDestroy();
          this.ngOnInit();
        } else if (event instanceof NavigationStart && urlString == '/fiche') {
          this.filterCacheService.storeFilteredInputs(this.filtersInput);
          this.filterCacheService.storeSecondChipInputList(
            this.secondChipInputList
          );
          this.filterCacheService.storeMainChipInputList(
            this.mainChipInputList
          );
          this.filterCacheService.storeIsDist(this.isDist);
          this.filterCacheService.storeTagsSelected(
            this.checkedList.map((element) => element.name)
          );

          this.filterCacheService.storeIsDist(this.isDist);
          this.filterCacheService.storeMinValue(this.minValue);
          this.filterCacheService.storeMaxValue(this.maxValue);
          this.filterCacheService.storeMinValueElevation(
            this.minValueElevation
          );
          this.filterCacheService.storeMaxValueElevation(
            this.maxValueElevation
          );
          this.filterCacheService.storeDifficulty(this.difficultyValue);
          this.filterCacheService.storeIsLoop(this.isLoop);
          this.filterCacheService.storeIsLinear(this.isLinear);
          this.filterCacheService.storeIsCdesi(this.isCdesi);

          this.filterCacheService.storeStartDate(
            this.startDate.value?.toString() ?? null
          );
          this.filterCacheService.storeEndDate(
            this.endDate.value?.toString() ?? null
          );
          this.filterCacheService.storeIsSortieNature(this.sortieNature);

          this.filterCacheService.storeIsPMR(this.disabledAccess);
        }
      })
    );
  }

  ngOnDestroy() {
    this.webWorker.terminate();
    const divChip = document.querySelector('#divChip');
    if (divChip != null) this.resizeEvent.unobserve(divChip);
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /**
   * Function that we use to determine from stored filters if a checlbox is selected or not.
   * @param catName
   */
  public isCheckboxSelected(catName: string): boolean {
    if (this.catFilter != null) return catName == this.catFilter;
    return this.tagsSelected.includes(catName);
  }

  public isSortieNatureCheckboxSelected(): boolean {
    return this.sortieNature;
  }

  public handleSortieNatureValue(triggerFilterbyTag: boolean = true) {
    if (triggerFilterbyTag) {
      this.sortieNature = !this.sortieNature;
      this.handleManualCheckedList('3', 'sortie_nature', '2', false);
      this.filterByTag();
    } else if (this.sortieNature === true) {
      this.handleManualCheckedList('3', 'sortie_nature', '2', false);
    }
  }

  public isPMRCheckboxSelected(): boolean {
    return this.disabledAccess ?? false;
  }

  public isCdesiCheckboxSelected(): boolean {
    return this.isCdesi;
  }

  public handleCdesiValue(triggerFilterbyTag: boolean = true) {
    if (triggerFilterbyTag) {
      this.isCdesi = !this.isCdesi;
      this.handleManualCheckedList('1', 'circuit_cdesi', null, false);
      this.filterByTag();
    } else if (this.isCdesi === true) {
      this.handleManualCheckedList('1', 'circuit_cdesi', null, false);
    }
  }

  public getCatNode(): TagNested[] {
    return [
      this.subCatId === undefined
        ? this.tagNested.find((tn) => tn.cat.catId === this.catId)
        : this.tagNested
            .find((tn) => tn.cat.catId === this.catId)
            .children.find((ctn) => ctn.cat.subCatId === this.subCatId),
    ];
  }

  public maxSlideDistValue(value: number): string {
    return `${Config.maxDist - value}km`;
  }

  public minSlideDistValue(value: number): string {
    return `${value}km`;
  }

  public maxSlideDurValue(value: number): string {
    return `${Math.floor((Config.maxDur - value) * 10) / 10} h`;
  }

  public minSlideDurValue(value: number): string {
    return `${value}h`;
  }

  public slideElevationValue(value: number): string {
    return `${value}m`;
  }

  getDurationStringified(duration: number): string {
    let minutes = duration % 1;
    let hours = duration - minutes;
    minutes = Math.round(minutes * 60);
    return `${hours}h${minutes < 10 ? '0' : ''}${minutes}`;
  }

  public checkDifficultyValue(id: number) {
    return this.difficultyValue?.some((el) => el.id === id) ? true : false;
  }

  public setDifficultyValue(
    id: number,
    name: string,
    triggerFilterbyTag: boolean = true
  ) {
    let toggledIndex =
      this.difficultyValue?.findIndex((element) => element.id === id) ?? -1;

    if (this.difficultyValue === undefined) this.difficultyValue = [];

    if (toggledIndex !== -1) this.difficultyValue.splice(toggledIndex, 1);
    else this.difficultyValue.push({ id: id, name: name });

    this.handleManualCheckedList('1', 'circuit_difficulty-' + id, null, false);
    if (triggerFilterbyTag) this.filterByTag();
  }

  public setPMRValue(triggerFilterbyTag: boolean = true) {
    if (triggerFilterbyTag) {
      this.disabledAccess = !this.disabledAccess;
      this.handleManualCheckedList('-1', 'PMR', null, false);
      this.filterByTag();
    } else if (this.disabledAccess === true) {
      this.handleManualCheckedList('-1', 'PMR', null, false);
    }
  }

  public getLinearValue() {
    return this.isLinear ?? false;
  }

  public setLinearValue(triggerFilterbyTag: boolean = true) {
    if (this.isLinear === undefined || this.isLinear === null)
      this.isLinear = false;
    if (triggerFilterbyTag) {
      this.isLinear = !this.isLinear;
      this.handleManualCheckedList('1', 'circuit_linear', null, false);
      this.filterByTag();
    } else if (this.isLinear === true) {
      this.handleManualCheckedList('1', 'circuit_linear', null, false);
    }
  }

  public getLoopValue() {
    return this.isLoop ?? false;
  }

  public setLoopValue(triggerFilterbyTag: boolean = true) {
    if (this.isLoop === undefined || this.isLoop === null) this.isLoop = false;
    if (triggerFilterbyTag) {
      this.isLoop = !this.isLoop;
      this.handleManualCheckedList('1', 'circuit_loop', null, false);
      this.filterByTag();
    } else if (this.isLoop === true) {
      this.handleManualCheckedList('1', 'circuit_loop', null, false);
    }
  }

  /** Some filters don't work like intended with the default system so we need to handle them a bit more artisanally */
  public handleManualCheckedList(
    catId: string,
    name: string,
    subCatId: string,
    isTag: boolean
  ) {
    const tmpValue = {
      catId: catId,
      name: name,
      subCatId: subCatId,
      isTag: isTag,
    };
    let elementIndex =
      this.manualCheckedList.findIndex((element) => element.name === name) ??
      -1;
    if (elementIndex === -1) this.manualCheckedList.push(tmpValue);
    else this.manualCheckedList.splice(elementIndex, 1);
  }

  /**
   * J'utile ça à l'initialisation de la vue pour mettre en place la selection de range de distance/durée de circuit.
   */
  private setCircuiCursorOptions() {
    if (this.isDist) {
      this.options = {
        floor: 0,
        ceil: 60,
        step: 1,
        hidePointerLabels: true,
        hideLimitLabels: true,
      };
      return;
    }
    this.options = {
      floor: 0,
      ceil: 7,
      step: 0.25,
      hidePointerLabels: true,
      hideLimitLabels: true,
    };
  }

  /**
   * Fonction appelé à chaque fois que le type de filtrage distance/durée est modifié.
   */
  public toggleCircuitFilter() {
    this.isDist = !this.isDist;
    if (this.isDist) {
      this.options = {
        floor: this.minDistValue,
        ceil: this.maxDistValue,
        step: 1,
        hidePointerLabels: true,
        hideLimitLabels: true,
      };
      this.minValue = this.minDistValue;
      this.maxValue = this.maxDistValue;
    } else {
      this.options = {
        floor: this.minTimeValue,
        ceil: this.maxTimeValue,
        step: 0.25,
        hidePointerLabels: true,
        hideLimitLabels: true,
      };
      this.minValue = this.minTimeValue;
      this.maxValue = this.maxTimeValue;
    }
    const indexToRemove = this.manualCheckedList.findIndex(
      (element) => element.name === 'circuit_dist-duration' ?? -1
    );
    if (indexToRemove !== -1) this.manualCheckedList.splice(indexToRemove, 1);
    this.filterByTag();
  }

  public handleCircuitDistDurationFilter(triggerFilterbyTag: boolean = true) {
    if (
      (this.isDist === true && this.minValue === 0 && this.maxValue === 60) ||
      (this.isDist === false && this.minValue === 0 && this.maxValue === 7)
    ) {
      // If filter values are default, remove element from manualCheckedList
      const indexToRemove = this.manualCheckedList.findIndex(
        (element) => element.name === 'circuit_dist-duration' ?? -1
      );
      if (indexToRemove !== -1) this.manualCheckedList.splice(indexToRemove, 1);
    } else {
      const index = this.manualCheckedList.findIndex(
        (element) => element.name === 'circuit_dist-duration' ?? -1
      );
      if (index === -1)
        this.manualCheckedList.push({
          name: 'circuit_dist-duration',
          catId: '1',
          subCatId: null,
          isTag: false,
        });
    }
    if (triggerFilterbyTag) this.filterByTag();
  }

  public handleElevationFilter(triggerFilterbyTag: boolean = true) {
    if (this.minValueElevation === 0 && this.maxValueElevation === 1000) {
      // If filter values are default, remove element from manualCheckedList
      const indexToRemove = this.manualCheckedList.findIndex(
        (element) => element.name === 'circuit_elevation' ?? -1
      );
      if (indexToRemove !== -1) this.manualCheckedList.splice(indexToRemove, 1);
    } else {
      const index = this.manualCheckedList.findIndex(
        (element) => element.name === 'circuit_elevation' ?? -1
      );
      if (index === -1)
        this.manualCheckedList.push({
          name: 'circuit_elevation',
          catId: '1',
          subCatId: null,
          isTag: false,
        });
    }
    if (triggerFilterbyTag) this.filterByTag();
  }

  /**
   * Filtering list card by date.
   * @param {CardList} card
   * @returns {boolean}
   */
  public filterByDate(card: CardList): boolean {
    const isStartSelected =
      this.startDate.value != null && this.startDate.value != '';
    const isEndSelected =
      this.endDate.value != null && this.endDate.value != '';
    if (isEndSelected) {
      const dateStart = isStartSelected ? this.startDate.value : Date.now();

      const rangeEnd = new Date(this.endDate.value.getTime() + 86399000);

      const dateStartCard = new Date(card.dateStart);
      const dateEndCard = new Date(card.dateEnd);
      return (
        (dateStart <= dateStartCard && dateStartCard <= rangeEnd) ||
        (dateStart <= dateEndCard && dateEndCard <= rangeEnd) ||
        (dateStartCard <= dateStart && dateEndCard >= rangeEnd)
      );
    } else if (isStartSelected) {
      const start = new Date(card.dateStart);
      return start >= this.startDate.value;
    }
    return false;
  }

  resetDateRange(): void {
    this.startDate.reset();
    this.endDate.reset();
    this.filterByTag();
  }

  public addFilterChip(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value && !this.filtersInput.includes(value)) {
      this.filtersInput.push(value);
      this.secondChipInputList.push(value);
      this.filterByTag();
    }

    // Clear the input value
    event.chipInput.clear();
    this.filtersCount.sharedValue$.next(this.filtersInput.length);
  }

  /**
   * Callback function to remove a main chip from global search.
   * @param {string} value This is the value of main chip list that we wish to remove from tag list.
   */
  public removeMainFilterChip(value: string) {
    this.mainChipInputList = this.mainChipInputList.filter(
      (mainChipValue) => mainChipValue != value
    );
    this.filtersInput = this.filtersInput.filter((f) => f !== value);
    if (this.filterFieldInput === value) {
      this.filterFieldInput = '';
      this.filterField.sharedValue$.next({ filter: '' });
    }
    this.filtersCount.sharedValue$.next(this.filtersInput.length);
    this.filterByTag();
  }

  /**
   * Callback function to remove a secondary chip from global search.
   * @param value This is the value of secondary chip list that we wish to remove from tag list.
   */
  public removeSecondaryFilterChip(value: string) {
    this.secondChipInputList = this.secondChipInputList.filter(
      (mainChipValue) => mainChipValue != value
    );
    this.filtersInput = this.filtersInput.filter((f) => f !== value);
    if (this.filterFieldInput === value) {
      this.filterFieldInput = '';
      this.filterField.sharedValue$.next({ filter: '' });
    }
    this.filtersCount.sharedValue$.next(this.filtersInput.length);
    this.filterByTag();
  }

  public updateFilter() {
    this.filteredCards.emit(this.cards);
    this.sendClose();
  }

  public sendClose() {
    this.filterPanel?.next(true);
  }

  public toggleRemoveMinHeight() {
    this.removeMinHeight = !this.removeMinHeight;
  }

  private setFiltersList(checkedList: any) {
    var finalFilters = {
      allowedCategories: [] as string[],
      allowedHeritageSubCat: [] as string[],
      allowedHeritageSubSubCat: [] as string[],
      allowedCircuitTypes: [] as string[],
      allowedServices: [] as string[],
      allowedAgenda: [] as string[],
    };

    const circuitTypes = [
      'Walk',
      'MountainBike',
      'HybridBike',
      'Bike',
      'Horse',
      'Trail',
    ];

    for (let node of checkedList) {
      if (node.subCatId === null)
        finalFilters.allowedCategories.push(node.catId);

      if (node.catId === '0') {
        if (node.isTag !== true)
          finalFilters.allowedHeritageSubCat.push(node.subCatId);
        else finalFilters.allowedHeritageSubSubCat.push(node.name);
      } else if (node.catId === '1') {
        if (circuitTypes.includes(node.name))
          finalFilters.allowedCircuitTypes.push(node.subCatId);
      } else if (node.catId === '2') {
        finalFilters.allowedServices.push(node.subCatId);
      } else if (node.catId === '3') {
        finalFilters.allowedAgenda.push(node.subCatId);
      }
    }
    return finalFilters;
  }

  public filterByTag() {
    this.filtersCount.sharedValue$.next(
      this.filtersInput.length +
        this.checkedList.length +
        this.manualCheckedList.length
    );
    let cards: CardList[];

    const totalCheckedList = this.checkedList.concat(this.manualCheckedList);

    // Prepare global checks
    const filtersList = this.setFiltersList(totalCheckedList);
    const subFilter = totalCheckedList.filter(
      (res) => res.subCatId == '38' && res.isTag == true
    );

    let totalFilters = subFilter.length;

    for (let key in filtersList) {
      if (filtersList.hasOwnProperty(key)) {
        totalFilters += filtersList[key].length;
      }
    }

    const atLeastOneFilter =
      totalFilters > 0 ||
      (this.startDate.value != null && this.startDate.value != '') ||
      (this.endDate.value != null && this.endDate.value != '');

    if (this.allCards != null) {
      cards = this.allCards.filter((c: CardList) => {
        // Get some info from the card
        const cardCatId = c.category?.toString() ?? null;
        const cardSubCatId = c.idSubcategory?.toString() ?? null;
        const cardName = c.mainTag?.name ?? '';
        const circuitType = c.circuitType?.toString() ?? null;

        let toAdd = filtersList.allowedCategories.includes(cardCatId);

        if (cardCatId === '0') {
          // Filters for heritage
          if (filtersList.allowedHeritageSubSubCat.includes(cardName))
            toAdd = true;
          else if (filtersList.allowedHeritageSubCat.includes(cardSubCatId))
            toAdd = true;
          else if (
            c.tags.some((tag) => tag.name === 'Insolite') &&
            filtersList.allowedHeritageSubCat.includes('-1')
          )
            toAdd = true;
        } else if (cardCatId === '1') {
          // Filters for circuits
          if (filtersList.allowedCircuitTypes.length > 0)
            toAdd = filtersList.allowedCircuitTypes.includes(circuitType);

          // Duration / Distance
          if (this.isDist === true)
            toAdd =
              toAdd &&
              c.distance >= this.minValue &&
              c.distance <= this.maxValue;
          else
            toAdd =
              toAdd &&
              c.duration >= this.minValue &&
              c.duration <= this.maxValue;

          // Denivele
          if (this.maxValueElevation < 1000 || this.minValueElevation > 0) {
            toAdd =
              toAdd &&
              c.positiveDenivele <= this.maxValueElevation &&
              c.positiveDenivele >= this.minValueElevation;
          }

          // Difficulty
          if (this.difficultyValue && c.difficulty) {
            toAdd =
              toAdd &&
              (this.difficultyValue?.length === 0 ||
                this.difficultyValue.some(
                  (element) => element.id === c.difficulty.id
                ));
          }

          // Loop / Linear
          if (
            (this.isLoop === false && this.isLinear === false) ||
            (this.isLoop === true && this.isLinear === true)
          )
            toAdd = toAdd;
          else if (this.isLinear) toAdd = toAdd && this.isLinear !== c.isLoop;
          else if (this.isLoop) toAdd = toAdd && this.isLoop === c.isLoop;

          // Labellise sport de nature
          if (this.isCdesi === true) toAdd = toAdd && c.isCdesi;
        } else if (cardCatId === '2') {
          // Filters for services
          if (c.idSubcategory.toString() == '38' && subFilter.length > 0) {
            toAdd = this.filterMappingProducteurLocaux(subFilter, c);
          } else {
            if (filtersList.allowedServices.includes(cardSubCatId))
              toAdd = true;
          }
        } else if (cardCatId === '3') {
          let addedOngoingEvents = false;
          let addedForthComingEvents = false;
          // Filters for agenda
          if (filtersList.allowedAgenda.includes('0'))
            addedOngoingEvents = this.filterOnGoingEvents(c);
          if (filtersList.allowedAgenda.includes('1'))
            addedForthComingEvents = this.filterForthComingEvents(c);
          if (
            !filtersList.allowedAgenda.includes('0') &&
            !filtersList.allowedAgenda.includes('1') &&
            filtersList.allowedCategories.includes('3')
          )
            toAdd = true;
          else toAdd = addedForthComingEvents || addedOngoingEvents;
          if (filtersList.allowedAgenda.includes('2'))
            toAdd = c.thematic === 'Sorties Nature';
          // toAdd = toAdd && this.filterByDate(c);
          if (
            (this.startDate.value != null && this.startDate.value != '') ||
            (this.endDate.value != null && this.endDate.value != '')
          )
            toAdd = this.filterByDate(c);
          // toAdd = filtersList.allowedCategories.includes('3');
        }

        return toAdd;
      });
    }

    if (this.disabledAccess === true && atLeastOneFilter) {
      if (totalFilters == 1)
        cards = this.allCards.filter(
          (c: CardList) => c.disabledAccess === true
        );
      else cards = cards.filter((c: CardList) => c.disabledAccess === true);
    }

    this._filterCards(!atLeastOneFilter ? this.allCards : cards);
  }

  filterMappingProducteurLocaux(
    subFilter: {
      name: string;
      catId: string;
      subCatId: string;
      isTag: boolean;
    }[],
    card: CardList
  ): boolean {
    if (card.categoryFiltersProducteursLocaux == null) return false;
    return subFilter.some((filter) => {
      const categoryKey = mappingProducteur[filter.name.toLocaleLowerCase()];
      return (
        categoryKey && card.categoryFiltersProducteursLocaux[categoryKey] === 1
      );
    });
  }

  filterOnGoingEvents(c: CardList) {
    const start = new Date(c.dateStart);
    const end = new Date(c.dateEnd);
    const now = Date.now();
    return start.getTime() <= now && end.getTime() >= now;
  }

  filterForthComingEvents(c: CardList) {
    const start = new Date(c.dateStart);
    const now = Date.now();
    return start.getTime() >= now;
  }

  public removeAllFilters() {
    this.cards = this.allCards;
    this.cardFilters = [];
    this.filtersCount.sharedValue$.next(0);
    this.isLoop = false;
    this.isLinear = false;
    this.maxValueElevation = 1000;
    this.minValueElevation = 0;
    this.maxValue = 60;
    this.minValue = 0;
    this.difficultyValue = [];
    this.isCdesi = false;

    this.startDate.reset();
    this.endDate.reset();
    this.sortieNature = false;

    this.manualCheckedList = [];

    this.disabledAccess = false;

    this.filteredCards.emit(this.cards);
  }

  public removeFilter(index: number) {
    this.filtersInput.splice(index, 1);
    this.filterByTag();
  }

  public iconName(node: { id: string; name: string }): string {
    return Object.keys(Config.categories).find(
      (c) => c.toLowerCase() === node.name.toLowerCase()
    )
      ? node.id
      : `_${node.id}`;
  }

  private _filterCards(cards?: CardList[]) {
    const filteredCards = cards;
    const data = {
      filtersInput: this.filtersInput,
      allCards: filteredCards,
    };
    this.triggerMapZoom.triggerZoom(data.allCards);
    this.webWorker.postMessage(data);
  }

  private _fetchData() {
    const observer = {
      next: (routeParams: any) => {
        if (routeParams.cat) {
          this.catId = routeParams.cat;
          this.subCatId =
            routeParams.subCat !== undefined || routeParams.subCat !== -1
              ? routeParams.subCat
              : null;
          this.catName =
            this.catId === '5'
              ? 'Suggestions'
              : Object.values(Config.categories)[parseInt(this.catId, 10)].name;
        } else {
          this.catId = undefined;
          this.subCatId = undefined;
        }
      },
    };
    this.subscriptions.push(this.activateRoute.params.subscribe(observer));

    // Add filter if needed
    // Might happen after global search
    const queryParamsObserver = {
      next: (queryParams: any) => {
        if (queryParams && queryParams.filter) {
          this.checkedList.push({
            name: queryParams.filter,
            catId: this.catId,
            subCatId: this.subCatId,
            isTag: true,
          });
        }
      },
    };
    this.subscriptions.push(
      this.activateRoute.params.subscribe(queryParamsObserver)
    );
  }

  private _getCards() {
    const requestCatId = this.catId === '5' ? undefined : this.catId;
    this.cardsService.getCardListPromise(requestCatId).then((cards) => {
      let cardList: CardList[];
      if (this.catId === '3' && !isNaN(parseInt(this.subCatId, 10))) {
        if (parseInt(this.subCatId, 10) === 0) {
          cardList = cards.filter((c: CardList) => {
            const start = new Date(c.dateStart);
            const end = new Date(c.dateEnd);
            const now = Date.now();
            if (start.getTime() <= now && end.getTime() >= now) {
              return c;
            }
          });
        } else if (parseInt(this.subCatId, 10) === 1) {
          cardList = cards.filter((c: CardList) => {
            const start = new Date(c.dateStart);
            const now = Date.now();
            if (start.getTime() >= now) {
              return c;
            }
          });
        } else if (parseInt(this.subCatId, 10) === 2) {
          cardList = cards.filter(
            (c: CardList) => c.thematic.toLowerCase() === 'sorties nature'
          );
        }
        cardList.sort(
          (a: CardList, b: CardList) =>
            new Date(a.dateStart).getTime() - new Date(b.dateStart).getTime()
        );
      } else if (this.catId === '1' && !isNaN(parseInt(this.subCatId, 10))) {
        cardList = cards
          .filter((c) =>
            FiltersComponent._translateCircuitType(
              c.circuitType,
              parseInt(this.subCatId, 10)
            )
          )
          .sort((a, b) => (a.title < b.title ? -1 : 1));
      } else if (this.catId === '5') {
        const options: ResponseData[] = JSON.parse(
          JSON.stringify(
            this.formService.inspirationTags.filter(
              (opt: ResponseData) => opt !== undefined
            )
          )
        );
        cardList = this.formService.fiches;
      } else if (
        !isNaN(parseInt(this.subCatId, 10)) &&
        parseInt(this.subCatId, 10) !== -1
      ) {
        cardList = cards
          .filter((c) => c.idSubcategory === Number(this.subCatId))
          .sort((a, b) => (a.title < b.title ? -1 : 1));
      } else {
        cardList = cards.sort((a, b) => (a.title < b.title ? -1 : 1));
        if (this.catId === '3') {
          cardList.sort(
            (a: CardList, b: CardList) =>
              new Date(a.dateStart).getTime() - new Date(b.dateStart).getTime()
          );
        }
      }
      this.allCards = cardList
        .map((mc) => this._addIcon(mc))
        .map((mc) => this._convertDifficulty(mc));
      this.cards = this.allCards;

      if (this.subCatId != undefined && this.subCatId === '-1') {
        this.checkedList = [
          {
            catId: '0',
            name: 'Insolite',
            subCatId: '-1',
            isTag: false,
          },
        ];
      } else {
        const index = this.checkedList.findIndex(
          (element) => element.name === 'Insolite' ?? -1
        );
        if (index !== -1) this.checkedList.splice(index, 1);
      }
      this.filterByTag();
    });
  }

  private _groupTagsByCategory(): void {
    const resultSubCategService = this.subCatService.getSubCategories();
    const subCatGroup: Record<string, SubCategory[]> = {};
    resultSubCategService.subcategories.forEach((sc: SubCategory) => {
      if (subCatGroup[sc.parentCategId] === undefined) {
        subCatGroup[sc.parentCategId] = [sc];
      } else {
        subCatGroup[sc.parentCategId].push(sc);
      }
    });
    const tagNested = this._buildNestedSubCat(subCatGroup);
    this._nestTags(tagNested);
  }

  private _buildNestedSubCat(
    subCatGrouped: Record<string, SubCategory[]>
  ): TagNested[] {
    const tagNested: TagNested[] = [];
    this.tagNested.map((val) => tagNested.push(Object.assign({}, val)));
    tagNested.forEach((c) => {
      subCatGrouped[c.cat.catId]?.forEach((sc) => {
        if (!c.children.find((ch) => ch.cat.subCatId === sc.id.toString())) {
          c.children.push({
            cat: {
              catId: c.cat.catId,
              name: sc.name,
              subCatId: sc.id.toString(),
              isTag: null,
            },
            children: [],
          });
        }
      });
    });
    const insolite: TagNested = {
      cat: {
        catId: '0',
        name: 'Insolite',
        subCatId: '-1',
        isTag: false,
      },
      children: [],
    };
    if (!tagNested[0].children.some((tg) => tg.cat.name == insolite.cat.name)) {
      tagNested[0].children.push(insolite);
    }

    return tagNested;
  }

  private _nestTags(tagNested: TagNested[]) {
    this.tagService
      .getAllTagsPromise()
      .then((t) => (this.tagNested = this._addTagToSubCat(tagNested, t.tags)));
  }

  private _addTagToSubCat(
    tagNested: TagNested[],
    tags: TagModel[]
  ): TagNested[] {
    tagNested.forEach((c) => {
      if (c.cat.catId !== '1' && c.cat.catId !== '3') {
        c.children !== undefined
          ? c.children.forEach((sc) => {
              sc.children = tags
                .filter((t) => t.idSubcategory?.toString() === sc.cat.subCatId)
                .map((t) => ({
                  cat: {
                    catId: c.cat.catId,
                    name: t.name,
                    subCatId: sc.cat.subCatId,
                    isTag: true,
                  },
                  children: [],
                }));
            })
          : (c.children =
              c.cat.catId === null
                ? tags
                    .filter((t) => t.idSubcategory === null)
                    .map((t) => ({
                      cat: {
                        catId: c.cat.catId,
                        name: t.name,
                        subCatId: null,
                        isTag: true,
                      },
                      children: [],
                    }))
                    .sort()
                : []);
      }
    });
    return tagNested;
  }

  private _addIcon(card: CardList): CardList {
    let url: string;
    if (parseInt(card.category, 10) !== 1) {
      url = `${Config.markerImage}${
        card.idSubcategory !== null ? card.idSubcategory : '_' + card.category
      }.png`;
    } else {
      // tslint:disable-next-line:no-bitwise
      const circuit = FiltersComponent._translateCircuitType(
        card.circuitType,
        1
      )
        ? 1
        : FiltersComponent._translateCircuitType(card.circuitType, 2)
        ? 2
        : FiltersComponent._translateCircuitType(card.circuitType, 4)
        ? 4
        : FiltersComponent._translateCircuitType(card.circuitType, 8)
        ? 8
        : FiltersComponent._translateCircuitType(card.circuitType, 16)
        ? 16
        : 32;
      url = `${Config.markerImage}circuit_${
        this.subCatId !== undefined ? this.subCatId : circuit
      }.png`;
    }

    card.icon = {
      url,
      size: new google.maps.Size(36, 50),
      scaledSize: new google.maps.Size(36, 50),
      anchor: new google.maps.Point(18, 50),
    };
    return card;
  }

  private _convertDifficulty(card: CardList): CardList {
    // in that case, card.difficulty is somehow a string and not a CircuitDifficulty
    if (card.difficulty && typeof card.difficulty === 'string') {
      let difficultyName = card.difficulty as string;
      card.difficulty = {
        id: DIFFICULTY_MAPPING[difficultyName],
        name: difficultyName,
      };
    }
    return card;
  }

  /**
   * Get teh main categ icon given the param.
   * Ma fonction — qui entre nous, est magnifique n'est-ce-pas ?
   * @param {any} cat
   * @returns The correct icon url.
   */
  getIconRef(cat: any): string {
    if (cat == null) return '';

    let ref: string;
    if (cat.cat.catId == '0') ref = 'icon_0';
    if (cat.cat.catId == '1') ref = 'icon_1';
    if (cat.cat.catId == '2') ref = 'icon_Services';
    if (cat.cat.catId == '3') ref = 'icon_Events';
    if (cat.cat.catId == '4') ref = 'icon_Games';
    return ref;
  }

  /**
   * On utilise ce genre de fonction car nous n'avons pas la main sur certaines data dont les label de subcateg.
   * Ceci nous permet de corriger les données (orthographes, etc)..
   * Ceci concerne le libéllé sur la zone filtre.
   * TODO Fix temporaire d'ortho de subcateg.
   * @param {string} subcat
   * @returns
   */
  getSubCategTitle(subcat: string): string {
    if (subcat == 'Patrimoine religieux et commemoratif')
      return 'Patrimoine religieux et commémoratif';
    if (subcat == 'Hébergement') return 'Hébergements';
    if (subcat == 'Activités et Loisirs') return 'Activités et loisirs';
    if (subcat == 'Demeures et Châteaux') return 'Demeures et châteaux';
    if (subcat == 'Arts et Culture') return 'Arts et culture';
    return subcat;
  }

  /**
   * Simple GA sending.
   * @param {string} event
   */
  public sendGaEvent(event: string, categ?: string, label?: string): void {
    this.gaService.sendEvent(event, categ, label);
  }
}
